import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';
import favicon from './assets/favicon-32.png';

// Set favicon dynamically so Vite resolves the asset path
const link = document.querySelector<HTMLLinkElement>("link[rel~='icon']") || document.createElement('link');
link.rel = 'icon';
link.type = 'image/png';
link.href = favicon;
document.head.appendChild(link);

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
